import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Alert from "../../../Common/Alert";
import DatatableFunc from "../../../Common/DatatableFunc";
import Http from "../../../Common/Http";
import IsLogin from "../../../Common/IsLogin";
import ReactDataTable from "../../../Common/ReactDataTable";

const List = () => {
  const location = useLocation();
  const [receiveData, setReceiveData] = useState([]);
  const [alert, setAlert] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(false);
  const [me, setMe] = useState([]);
  const [selectedStore, setSelectedStore] = useState(null);

  const fetchData = async () => {
    setLoading(true); // Start loading

    try {
      const me = await Http.get(`/me`);
      setMe(me?.data?.data);
      console.log(me?.data.data, "data");

      const resRole = await Http.get(`/staff-type-check`);
      setRole(resRole.data);

      const response = await Http.post("/all-store-stock-admin", {
        department_art_id: 15,
      });
      const formattedData = response?.data?.info?.map(item => ({
        ...item,
        stockQty: parseFloat(item.stockQty).toFixed(2), // Convert stockQty to 2 decimal places
        // issue_qty: item.issue_qty ? parseFloat(item.issue_qty).toFixed(2) : null, // Convert issue_qty to 2 decimal places if it exists
        // openingStockQty: parseFloat(item.openingStockQty).toFixed(2) // Convert openingStockQty to 2 decimal places
      }));
      setReceiveData(formattedData);
    } catch (error) {
      console.error("Fetch error:", error);
    }
    finally {
      setLoading(false); // Stop loading regardless of the outcome
    }
  };

  useEffect(() => {
    DatatableFunc();
    fetchData();
  }, []);

  const showAlert = (message, type) => {
    setAlert({
      message: message,
      type: type,
    });
    setTimeout(() => {
      setAlert(null);
    }, 4000);
  };

  // useEffect(() => {
  //   if (!location.state) {
  //     return;
  //   }
  //   showAlert(location.state.message, location.state.type);
  // }, [location]);

  // const deleteData = (id, deleteApiUrl, showMsg) => {
  //   Swal.fire({
  //     title: "Are you sure?",
  //     text: "You won't be able to revert this!",
  //     icon: "warning",
  //     showCancelButton: true,
  //     confirmButtonColor: "#3085d6",
  //     cancelButtonColor: "#d33",
  //     confirmButtonText: "Yes, delete it!",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       Http.delete("/" + deleteApiUrl + "/" + id).then((res) => {
  //         setReceiveData(res.data);
  //         Swal.fire("Deleted!", showMsg + " has been deleted.", "success");
  //       });
  //     }
  //   });
  // };
  console.log(me, "me");

  function formatType(value) {
    if (!value) return ""; // Handle empty or undefined values
    return value
      .split("_") // Split the string by underscores
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) // Capitalize each word
      .join(" "); // Join the words back with spaces
  }

  const cols = [
    { field: "code", header: "Code" },
    { field: "name", header: "Name" },
    // { field: "openingStockQty", header: "Opening Stock" },
    // { field: "issue_qty", header: "Consumption" },
    { field: "stockQty", header: "Stock" },
    // { field: "type", header: "type" },
    {
      // field: "type",
      header: "Type",
      field: (rowData) => formatType(rowData.type), // Use formatType function
    },
    // {
    //   field: (rowData) => me.department_art_id === 2 && rowData?.id === 1 ?  rowData.stockQty * 20   : (me.department_art_id === 3 ) && rowData?.id === 1 ? rowData.stockQty * 20 : rowData.stockQty,
    //   header: "Stock"
    // },
  ];

  const handleStoreChange = (event) => {
    setSelectedStore(parseInt(event.target.value));
    // You can also handle any additional logic based on the selected store here
  };

  const handleSubmit = async (storeId) => {
    if (!storeId) {
      showAlert("Please select a store.", "error");
      return;
    }

    setLoading(true);
    try {
      const response = await Http.post("/all-store-stock-admin", {
        department_art_id: storeId,
      });
      showAlert("Store submitted successfully!", "success");
      console.log(response.data); // Handle the response as needed
      const formattedData = response?.data?.info?.map(item => ({
        ...item,
        stockQty: parseFloat(item.stockQty).toFixed(2), // Convert stockQty to 2 decimal places
        // issue_qty: item.issue_qty ? parseFloat(item.issue_qty).toFixed(2) : null, // Convert issue_qty to 2 decimal places if it exists
        // openingStockQty: parseFloat(item.openingStockQty).toFixed(2) // Convert openingStockQty to 2 decimal places
      }));
      setReceiveData(formattedData);
    } catch (error) {
      console.error("Submission error:", error);
      showAlert("Error submitting store.", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <IsLogin></IsLogin>
      <div>
        <div className="am-mainpanel">
          <div className="am-pagetitle">
            <h5 className="am-title">Store Stocks</h5>
          </div>

          <div className="am-pagebody">
            <Alert alert={alert} />

            <div className="card">
              <div className="d-flex align-items-center mb-3">
                <label
                  className="col-form-label mr-3"
                  style={{ fontWeight: "bold", fontSize: "1.2rem" }}
                >
                  Select Store:
                </label>
                <div className="btn-group">
                  <button
                    className="btn btn-primary"
                    onClick={() => handleSubmit(15)}
                  >
                    General Store
                  </button>
                  <button
                    className="btn btn-primary mx-3"
                    onClick={() => handleSubmit(20)}
                  >
                    Decel Store
                  </button>
                  <button
                    className="btn btn-primary"
                    onClick={() => handleSubmit(21)}
                  >
                    Packaging Store
                  </button>
                </div>
              </div>
            </div>

            <div className="card pd-20 pd-sm-40">
              <ReactDataTable
                cols={cols}
                receiveData={receiveData}
                isLoading={loading}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default List;
